<div
    *ngIf="entityInternal"
    class="staffCard agpr-contextMenu-parent"
>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        class="staffCard-container"
        (agprClickUnless)="onCardClicked(entityInternal)"
        [agprClickUnlessSelectors]="['a', 'agpr-checkbox']"
        [attr.aria-label]="'Discover.universal.staffCard.label' | localize: {first: entityInternal.firstName, last: entityInternal.lastName}"
        (keydown)="onKeydown($event)"
    >
        <div class="checkbox">
            <agpr-checkbox
                [id]="id + '_checkbox'"
                [disabled]="disableSelection"
                [value]="entityInternal"
                [hiddenLabel]="entityInternal.firstName + ' ' + entityInternal.lastName"
                [(ngModel)]="selectedResults"
                (onChange)="checkboxClick()"
            ></agpr-checkbox>
        </div>

        <div class="thumbnail">
            <img
                class="thumbnail-img"
                [agprImageSrc]="entityInternal.avatarUrl | twitterAvatarSize:twitterAvatarSizes.bigger"
                alt=""
                [agprDefaultImage]="imageDefault.SMALL_CONTACT"
            />
            <span
                *ngIf="listMemberships.length > 0 && listMemberships.length === workingLists.length"
                role="img"
                class="fa-regular fa-duotone fa-check thumbnail-bubble"
                [agprTooltip]="listMembershipTooltip"
                [escape]="false"
            ></span>
            <span
                *ngIf="listMemberships.length > 0 && listMemberships.length !== workingLists.length"
                class="thumbnail-bubble"
                [agprTooltip]="listMembershipTooltip"
                [escape]="false"
            >
                {{ listMemberships.length }}
            </span>
        </div>

        <div class="description">
            <div class="description-title overflowEllipsis">
                <a
                    class="description-title-name"
                    href="#contact-profile"
                    [id]="entityInternal.id + '_staff_contact_profile'"
                    (click)="onCardClicked(entityInternal,$event); $event.preventDefault()"
                    agprTooltip="Discover.universal.contactNameLink.tooltip"
                    tooltipPosition="top"
                >
                    {{entityInternal.firstName}} {{entityInternal.lastName}}
                </a>
                <span
                    role="img"
                    class="fa-solid fa-user description-title-icon"
                    [attr.aria-label]="'Discover.universal.contactLinkIcon'"
                ></span>
            </div>
            <div
                *ngIf="entityInternal.selectedEmployment?.jobTitle"
                class="description-jobtitle overflowEllipsis"
            >
                {{entityInternal.selectedEmployment?.jobTitle}}
            </div>
        </div>
    </div>
    <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->

    <div class="subjects">
        <agpr-chip-container
            [id]="id + '_subjectChips'"
            [chips]="entityInternal.subjectChips"
            [readonly]="true"
            [plainMode]="true"
            overflowMessage='Discover.targeting.result.viewsubjects'
        ></agpr-chip-container>
    </div>

    <div class="agpr-contextMenu top right">
        <agpr-button
            [icon]="'fa-regular fa-arrow-up-right-and-arrow-down-left-from-center'"
            (click)="onCardClicked(entityInternal)"
            class="contextMenu-button"
            tooltip="Discover.entityProfile.expand"
            tooltipPosition="top"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
        <agpr-button
            [icon]="'fa-regular fa-duotone fa-user-plus'"
            tooltip="Discover.targeting.actions.manageLists"
            tooltipPosition="top"
            (click)="openManageListDialog(entityInternal)"
            class="contextMenu-button"
            [style]="buttonTypes.contextMenu"
        ></agpr-button>
    </div>
</div>
